import gql from 'graphql-tag';
import { ImageFields, VideoFields } from '../common-fields.queries';
/**
 * Fields that are needed for both PLA/PDP.
 * When adding to this query make sure it is actually needed on both Pages
 */
export const ProductFamilyFields = gql`
	${VideoFields}
	${ImageFields}
	fragment ProductFamilyFields on ProductFamily {
		id
		pedProductPhone
		application
		url
		title
		productId
		breadcrumbs {
			name
			url
		}
		baseCategory {
			id
			name
		}
		businessCategory {
			id
			name
		}
		media {
			... on Image {
				...ImageFields
			}
			... on Video {
				...VideoFields
			}
		}
		hasFreeInstallation
		hasRecommendedOptions
		isConfigurable
		hasAccessories
		freightCost
		type
	}
`;
